import CommonTR from "./translated/tr/common/common.json";
import BurnModalTR from "./translated/tr/components/burnModal.json";
import FilterDropdownTR from "./translated/tr/components/filterDropdown.json";
import LoadingErrorMessageTR from "./translated/tr/components/loadingErrorMessage.json";
import LoadingTransactionsModalTR from "./translated/tr/components/loadingTransactionsModal.json";
import TableComponentTR from "./translated/tr/components/table.json";
import TiersModalTR from "./translated/tr/components/tiersModal.json";
import UnboughtTierTR from "./translated/tr/components/unboughtTier.json";
import ValidatorStakingModalTR from "./translated/tr/components/validatorStakingModal.json";
import WalletModalTR from "./translated/tr/components/walletModal.json";
import AccountToolsTR from "./translated/tr/pages/accountTools.json";
import AllPagesTR from "./translated/tr/pages/allPages.json";
import DashboardTR from "./translated/tr/pages/dashboard.json";
import DefiOnSolanaTR from "./translated/tr/pages/defiOnSolana.json";
import NFTGalleryTR from "./translated/tr/pages/nftGallery.json";
import ReferralsTR from "./translated/tr/pages/referrals.json";
import ReferrerInviteTR from "./translated/tr/pages/referrerInvite.json";
import StepStakingTR from "./translated/tr/pages/stepStaking.json";
import SwapLPTR from "./translated/tr/pages/swapLP.json";
import TransactionHistoryTR from "./translated/tr/pages/transactionHistory.json";

export const turkishSource = {
  common: CommonTR,
  components: {
    burnModal: BurnModalTR,
    table: TableComponentTR,
    tiersModal: TiersModalTR,
    filterDropdown: FilterDropdownTR,
    loadingErrorMessage: LoadingErrorMessageTR,
    loadingTransactionsModal: LoadingTransactionsModalTR,
    walletModal: WalletModalTR,
    unboughtTier: UnboughtTierTR,
    validatorStakingModal: ValidatorStakingModalTR,
  },
  pages: {
    accountTools: AccountToolsTR,
    allPages: AllPagesTR,
    dashboard: DashboardTR,
    defiOnSolana: DefiOnSolanaTR,
    nftGallery: NFTGalleryTR,
    stepStaking: StepStakingTR,
    swapLP: SwapLPTR,
    referrals: ReferralsTR,
    referrerInvite: ReferrerInviteTR,
    transactionHistory: TransactionHistoryTR,
  },
};
